<template>
  <div class="message-box">
    <b-modal ref="modal-window" :title="$t('debtors.comment.history-title')" size="lg modal-fullscreen-xxl-down" modal-class="message-box-modal" :loading="loading">
      <template #modal-body>
        <div v-for="(row, index) in list" :index="index">
          <div class="row">
            <label class="col-6"><b>{{ row.user_name }}</b></label>
            <div class="col-6 text-end">
              <label>Amount of debt: {{ row.amount_debt }}</label>
              <label class="ps-2">{{ formatDate(row.created_at) }}</label>
            </div>
          </div>
          <label>{{ row.comment }}</label>
          <hr/>
        </div>

        <Textarea
            v-model="form.comment"
            required
            :error="v$.form.comment.$error ? $t('debtors.comment.error.comment') : ''"
            :label="$t('client.comment')"
            :rows="5"
        />
      </template>

      <template #modal-footer>
        <span class="btn btn-secondary" @click="close()">{{ $t('client.cancel') }}</span>
        <span class="btn btn-primary" @click="submit()">{{ $t('client.create') }}</span>
      </template>
    </b-modal>
  </div>

  <message :message="message" link="success" :isVisible=isVisibleMsg @onVisible="changeIsVisibleMsg" />
</template>

<script src="./AddComment.js"></script>